import { PremiumStatus } from 'multirpc-sdk';
import { createSelector } from 'reselect';

import { selectIsLoggedIn } from 'modules/auth/store/selectors';

import {
  selectAccountStatus as selectAccountStatusData,
  selectAccountStatusState,
} from '../actions/fetchAccountStatus';

export const selectAccountStatus = createSelector(
  selectAccountStatusData,
  ({ status }) => status,
);

export const selectAccountStatusError = createSelector(
  selectAccountStatusState,
  ({ error }) => error,
);

export const selectAccountStatusLoaded = createSelector(
  selectAccountStatusState,
  ({ isSuccess }) => isSuccess,
);

export const selectIsFreemium = createSelector(
  selectAccountStatusData,
  selectIsLoggedIn,
  ({ isFreemium }, isLoggedIn) => isLoggedIn && isFreemium,
);

export const selectIsPremium = createSelector(
  selectAccountStatusData,
  selectIsLoggedIn,
  ({ isFreemium }, isLoggedIn) => isLoggedIn && !isFreemium,
);

export const selectIsEnterprise = createSelector(
  selectAccountStatusData,
  ({ isEnterprise }) => isEnterprise,
);

export const selectIsInactive = createSelector(
  selectAccountStatus,
  status => status === PremiumStatus.INACTIVE,
);
